import React from 'react';
import { Icon, Shelf, Stack, TextLink, Button, Modal, ButtonGroup } from '@chaser/components';
import useUser from '../../../hooks/useUser';
import ReviewService from '../../../services/review-service';
import useFetch from '../../../hooks/useFetch';
import useRemoteConfig from '../../../hooks/useRemoteConfig';
import useModal from '../../../hooks/useModal';
import LoadingMessage from '../../LoadingMessage';
import { useStorageState } from '../../../hooks/useGlobalState';

import style from './ReviewButton.module.scss';

const noop = async () => {};

const ReviewModal = ({ open, close, setHasReviewed, state, email }) => {
  const [loading, setLoading] = React.useState(true);

  function closeModal() {
    setHasReviewed({ hasReviewed: true });
    close(false);
  }

  return (
    <Modal
      disableClose={true}
      closeOnOutsideClick={false}
      open={open}
      toggle={close}
      title="Share your opinions about Chaser on G2"
      size="large"
    >
      <Modal.Body>
        {loading && <LoadingMessage />}
        <iframe
          src={`https://www.g2.com/partnerships/Chaser/users/login.embed?state=${state}&email=${email}`}
          width="100%"
          height="700px"
          style={{
            border: 'none',
            display: loading ? 'none' : 'block',
          }}
          title="Review"
          onLoad={() => setLoading(false)}
        />
      </Modal.Body>
      <Modal.Footer>
        <ButtonGroup>
          <Button onClick={closeModal} appearance="secondary">
            Not now
          </Button>
        </ButtonGroup>
      </Modal.Footer>
    </Modal>
  );
};

const ReviewButton = () => {
  const [open, setOpen] = React.useState(false);
  const [{ hasReviewed = false }, setHasReviewed] = useStorageState('review_modal');
  const showModal = useModal();
  const { emails } = useUser();
  const users = useRemoteConfig('review_users');
  const canReview = users && emails?.[0]?.address && users?.includes(emails[0].address);

  const { data, loading } = useFetch(!canReview ? noop : ReviewService.getG2Token, {
    throwOnError: false,
  });

  React.useEffect(() => {
    if (canReview && !loading && data?.state && !hasReviewed) {
      setOpen(true);
    }
  }, [canReview, loading, data, hasReviewed]);

  if (!canReview) return null;
  if (!data?.state) return null;
  if (loading) return null;

  return (
    <Stack mt="10px" gap="xsmall" alignItems="flex-start">
      <ReviewModal
        open={open}
        close={setOpen}
        setHasReviewed={setHasReviewed}
        state={data.state}
        email={emails[0].address}
      />
      <button onClick={() => setOpen(true)}>
        <Shelf gap="xsmall" as="div" className={style.star}>
          <Shelf gap="xxsmall" as="div">
            <Icon name="star" size={20} />
            <Icon name="star" size={20} />
            <Icon name="star" size={20} />
            <Icon name="star" size={20} />
            <Icon name="star" size={20} />
          </Shelf>
        </Shelf>
      </button>
      <TextLink
        loading={loading}
        as="button"
        onClick={() =>
          showModal(
            <ReviewModal
              setHasReviewed={setHasReviewed}
              state={data.state}
              email={emails[0].address}
            />,
          )
        }
        appearance="secondary"
      >
        Write a review
      </TextLink>
    </Stack>
  );
};

export default ReviewButton;
